import { appTemp } from '../actions/actionTypes';
import { handleHistoryFilePath } from '../utils';
export const appTempInitialState = {
    country: { name: 'United States', dialCode: '+1', code: 'US' },
    folderStack: [{ id: 'home', name: 'home' }],
    albumStack: [
        { id: 'home', name: 'home' },
        { id: 'recents', name: 'recents' },
    ],
    fileView: { visible: false, index: null, type: 'files' },
    fileTempLoaded: {},
    renamingFile: null,
    walletVerified: null,
    movingFile: null,
    emptySearch: false,
    isSearching: false,
    cancelMenus: 0,
    devices: [],
};
export default function (state = appTempInitialState, action) {
    switch (action.type) {
        case appTemp.COUNTRY:
            const countryPayload = action.payload;
            return { ...state, country: countryPayload };
        case appTemp.RESET_APP_TEMP_STATE:
            return appTempInitialState;
        case appTemp.OPEN_FOLDER:
            const openFolderPayload = action.payload;
            return { ...state, folderStack: [...state.folderStack, openFolderPayload] };
        case appTemp.CLOSE_FOLDER:
            handleHistoryFilePath(state.folderStack);
            if (state.folderStack.length === 1)
                return state;
            const folderStackCopy = [...state.folderStack];
            folderStackCopy.pop();
            return { ...state, folderStack: folderStackCopy };
        case appTemp.SET_FOLDER:
            const setFolderPayload = action.payload;
            let removeCount = 0;
            const stack = [...state.folderStack];
            while (state.folderStack.length > 1 &&
                state.folderStack[state.folderStack.length - 1].id !== setFolderPayload) {
                state.folderStack.pop();
                removeCount -= 1;
            }
            handleHistoryFilePath(stack, removeCount);
            return { ...state };
        case appTemp.RESET_FOLDER_STACK:
            return { ...state, folderStack: [{ id: 'home', name: 'home' }] };
        case appTemp.SHOW_FILE_VIEW:
            const showFileViewPayload = action.payload;
            return {
                ...state,
                fileView: { visible: true, index: showFileViewPayload.index, type: showFileViewPayload.type },
            };
        case appTemp.HIDE_FILE_VIEW:
            return { ...state, fileView: { visible: false, index: null, type: 'files' } };
        case appTemp.FILE_VIEW_SCROLL:
            const fileViewScrollPayload = action.payload;
            const newIndex = fileViewScrollPayload === 'ArrowRight' ? state.fileView.index + 1 : state.fileView.index - 1;
            return { ...state, fileView: { ...state.fileView, index: newIndex } };
        case appTemp.OPEN_ALBUM:
            const openAlbumPayload = action.payload;
            return { ...state, albumStack: [...state.albumStack, openAlbumPayload] };
        case appTemp.CLOSE_ALBUM:
            if (state.albumStack.length === 1)
                return state;
            const albumStackCopy = [...state.albumStack];
            albumStackCopy.pop();
            return { ...state, albumStack: albumStackCopy };
        case appTemp.FILE_TEMP_LOADED:
            const fileTempLoadedPayload = action.payload;
            return { ...state, fileTempLoaded: { ...state.fileTempLoaded, [fileTempLoadedPayload]: true } };
        case appTemp.IS_EMTPY_SEARCH:
            const isEmptySearchPayload = action.payload;
            return { ...state, emptySearch: isEmptySearchPayload };
        case appTemp.IS_SEARCHING:
            const isSearchingPayload = action.payload;
            return { ...state, isSearching: isSearchingPayload };
        case appTemp.RENAMING_FILE:
            const renamingFilePayload = action.payload;
            return { ...state, renamingFile: renamingFilePayload };
        case appTemp.CANCEL_MENUS:
            return { ...state, cancelMenus: state.cancelMenus + 1 };
        case appTemp.MOVING_FILE:
            const movingFilePayload = action.payload;
            return { ...state, movingFile: movingFilePayload };
        case appTemp.DISPATCH_APPTEMP_PROPERTY:
            const dispatchAppTempPropertyPayload = action.payload;
            return { ...state, ...dispatchAppTempPropertyPayload };
        case appTemp.FETCH_DEVICES:
            const fetchDevicesPayload = action.payload;
            return { ...state, devices: fetchDevicesPayload };
        default:
            return state;
    }
}
